import * as Collections from 'typescript-collections';
import { DateTime } from 'luxon';
import { InventoryItems } from './RequestModels';

export class PropertyAuthorization {
    public PropertyId: number;
    public DeptId: number;
    public ModuleCode: string;
    public ActionCode: string;
    public IsAllowed: boolean;
}

export class QuickCallConfig {
    public PropertyId: number;
    public DEPARTMENTID: number;
    public POSITION1: number;
    public POSITION2: number;
    public POSITION3: number;
    public POSITION4: number;
    public POSITION5: number;
    public POSITION6: number;
}

export class LicensedDevices {
    public CODE: number;
    public PropertyID: number;
    public DEVICENAME: string;
    public DEVICEID: string;
    public ACTIVE: boolean;
    public MinibarPosting: boolean;
    public RoomStatusUpdate: boolean;
    public HouseView: boolean;
    public FOView: boolean;
    public DeviceType: string;
    public DeviceCode: string;
    public WhiteBoard: boolean;
    public EnabledLogs: boolean;
}

export class PropertyZoneUrl {
    public PropertyId: number;
    public PropertyCode: string;
    public HousekeepingZoneUrl: string = '';
    public HousekeepingWebUrl: string = '';
    public InspectionZoneUrl: string = '';
    public InspectionWebUrl: string = '';
    public IsDefault = false

    static FromResponse(obj) {
        if (!obj || !obj.PropertyId || !obj.PropertyCode) {
            return null;
        }
        return Object.assign(new PropertyZoneUrl(), obj);
    }
}

export class PropertyAppFeatures {
    public AdvanceSecurity = false; // "0"
    public WebAuthExpiry = 30 //"30"

    public PreArrivalDaysLimit = 1;
    public CheckOutDaysLimit = 1; // "1"

    public MINIBAR_VOID_ALLOWED = true // "1"
    public MINIBAR_VOID_DURATION_SECS = 86400; // "86400"
    public MinibarHopTime = 5 // "5"
    public MinibarSameRoomRepostTime = 5; // "5"
    public MinibarShowRepostAlert = false // "FALSE"
    public MinibarShowSeekBar = false; // "TRUE"
    public MinibarTotalSeekTime = 20; // "20"
}

export class StaffBasicInfo {
    public StaffId: number;
    public LName: string;
    public FName: string;
    public DepartmentId: number;
    public Department: string;
    public DesignationId: number;
    public Designation: string;
    public Properties: Array<PropertyBasicInfo>;
    public ChainId: number;
    public PropertyId: number;
    public LanguageCode: string;
    public DeviceType: string;
    public DeviceId: string;
    public IsPropertyAdmin: boolean;
    public HasImage: boolean;
    public PropertyAuthorizations: Array<PropertyAuthorization> = [];
    public Settings: string;
    public LicensedDevices: Array<LicensedDevices>;
    public QuickCall: Array<QuickCallConfig>;
    public IsServiceStaff: boolean;
    public IsAlertPopupAudioEnabled: boolean;
    public Licence: Array<ExpiredLicence>;
    public ActiveLicences: Array<ActiveLicences>;
    public PasswordExpiryDate?: DateTime;
    public PwdPromptDays?: number;
    public AppFeatures: { [PropertyId: string]: PropertyAppFeatures};
}

export class ActiveLicences {
    public PropertyId: number;
    public MODULE_CODE: string;
    public RoleModule: string;
}

export class PropertyBasicInfo {
    public PropertyId: number;
    public ChainId: number;
    public PropertyCode: string;
    public PropertyName: string;
    public TimeZoneId: number;
    public BaseUtcOffset: number;
    public PropertyDateFormat: string;
    public PropertyTimeFormat: string;
    public ShowChangePassword: boolean;
}

export class ExpiredLicence {
    public Module_Code: string;
    public Module_Name: string;
    public PropertyId: number;
    public ValidTillDate: string;
}

export class LocationLookup {
    public Id: number;
    public ZoneId: number;
    public Description: string;
    public Sections: Array<number> = [];
}

export class GenericMaster {
    public Id: number;
    public Name: string;
}

export class DepartmentMaster {
    public Id: number;
    public Name: string;
    public IsServiceDepartment?: boolean;
}

export class SkillLookup {
  public Id: number;
  public Name: string;
  public DeptId: number;
}

export class SectionsLookup {
    public Id: number;
    public Name: string;
    public DeptId: number;
}

export class GenericMaster_String {
    public Id: string;
    public Name: string;
}

export class ReasonLookup {
    public ID: number;
    public ReasonType: string;
    public Description: string;
    public TimePeriod: number;
    public IVRCode: string;
}

export class CallDescriptionLookup {
    public Id: number;
    public CategoryId: number;
    public Description: string;
    public Priority: number;
    public ComplainType: number;
    public IsQuickCall: boolean = false;
    public IsduplicateAllowed = false;
    public IsDel: boolean;
    public IsFromKMTCategory?: boolean = false;
}

export class CallCategoryLookup {
    public Id: number;
    public SkillId: number;
    public IsKMTCategory = false;
    public Description: string;
}

export class LanguageLookup {
    public Language: string;
    public LanguageCode: string;
}

export class VIP {
    public Id: number;
    public Description: string;
    public Code: string;
    public NormalGuest: boolean;
}

export class GlitchCategory {
    public Id: number;
    public Description: string;
    public DeptId: number;
}
export class GlitchDescription {
    public Id: number;
    public Description: string;
    public CategoryId: number;
    public IsDel: boolean;
}
export class GlitchRecoveryOptionMaster {
    public Id: number;
    public Description: string;
    public ApprovedMaximumCost: number;
}
export class GlitchActionReason {
    public Id: number;
    public Description: string;
    public ReasonType: string;
}

export class PreferenceMapping {
    public Code: string;
    public Descr: string;
    public PrefType: string;
    public Type: string;
}

export class PropertyMainMasters_Transform {
    public Key: string;

    public Location = new Collections.Dictionary<string, string>();

    public CallCategories = new Collections.Dictionary<string, string>();
    public CallDescriptions = new Collections.Dictionary<string, string>();
    public Staff = new Collections.Dictionary<string, string>();
    public Reason = new Collections.Dictionary<string, string>();
    public Dept = new Collections.Dictionary<string, string>();
    public DeviceType = new Collections.Dictionary<string, string>();
    public ComplainStatus = new Collections.Dictionary<string, string>();
    public Desg = new Collections.Dictionary<string, string>();
    public Sections = new Collections.Dictionary<string, string>();
    public Skill = new Collections.Dictionary<string, string>();

    //public Language = new Collections.Dictionary<string, string>();
    public Groups = new Collections.Dictionary<string, string>();
    public ComplainTypes = new Collections.Dictionary<string, string>();
    public VIPs = new Collections.Dictionary<string, string>();
    public EventMaster = new Collections.Dictionary<string, string>();

    public GlitchRegistrationTypes = new Collections.Dictionary<string, string>();
    public GlitchCategories = new Collections.Dictionary<string, string>();
    public GlitchDescriptionMaster = new Collections.Dictionary<string, string>();
    public GlitchRecoveryOptionMaster = new Collections.Dictionary<string, string>();
    public GlitchActionReason = new Collections.Dictionary<string, string>();

    public PropertyID: number;
    public LanguageCode: string;
    public LastUpdate: Date;
    public LastUpdate_String: string;
}

export class PropertyMainMasters {
    public Key: string;

    public Location: Array<LocationLookup> = [];

    public CallCategories: Array<CallCategoryLookup> = [];
    public CallDescriptions: Array<CallDescriptionLookup> = [];
    public Staff: Array<GenericMaster> = [];
    public Reason: Array<ReasonLookup> = [];
    public Dept: Array<DepartmentMaster> = [];
    public DeviceType: Array<GenericMaster> = [];
    public ComplainStatus: Array<GenericMaster_String> = [];
    public Desg: Array<GenericMaster> = [];
    public Sections: Array<SkillLookup> = [];
    public Skill: Array<SkillLookup> = [];

    public Language: Array<LanguageLookup> = [];
    public Groups: Array<GenericMaster> = [];
    public ComplainTypes: Array<GenericMaster> = [];
    public VIPs: Array<VIP> = [];
    public EventMaster: Array<GenericMaster> = [];

    public GlitchRegistrationTypes: Array<GenericMaster> = [];
    public GlitchCategories: Array<GlitchCategory> = [];
    public GlitchDescriptionMaster: Array<GlitchDescription> = [];
    public GlitchRecoveryOptionMaster: Array<GlitchRecoveryOptionMaster> = [];
    public GlitchActionReason: Array<GlitchActionReason> = [];

    public PropertyID: number;
    public LanguageCode: string;
    public LastUpdate: Date;
    public LastUpdate_String: string;
    public Group: Array<GenericMaster> = [];
    public InventoryCallDescriptionMaster: Array<InventoryItems> = [];
    public PreferenceMapping: Array<PreferenceMapping> = [];

    public TransformedObjects = new PropertyMainMasters_Transform();
}



export class PropertyMainMastersHelper {
    public TransformGenericMaster(lst: Array<GenericMaster>): Collections.Dictionary<string, string> {
        let ret = new Collections.Dictionary<string, string>();
        if (lst == null)
            return ret;

        for (let i = 0; i < lst.length; i++) {
            let row = lst[i];
            ret.setValue(row.Id.toString(), row.Name);
        }

        return ret;
    }

    public TransformGenericMaster_String(lst: Array<GenericMaster_String>): Collections.Dictionary<string, string> {
        let ret = new Collections.Dictionary<string, string>();
        if (lst == null)
            return ret;

        for (let i = 0; i < lst.length; i++) {
            let row = lst[i];
            ret.setValue(row.Id, row.Name);
        }

        return ret;
    }

    public Transform_Id_Description(lst: Array<any>): Collections.Dictionary<string, string> {
        let ret = new Collections.Dictionary<string, string>();
        if (lst == null)
            return ret;

        for (let i = 0; i < lst.length; i++) {
            let row = lst[i];
            ret.setValue(row.Id.toString(), row.Description);
        }

        return ret;
    }

    public TransformReasonLookup(lst: Array<ReasonLookup>): Collections.Dictionary<string, string> {
        let ret = new Collections.Dictionary<string, string>();
        if (lst == null)
            return ret;

        for (let i = 0; i < lst.length; i++) {
            let row = lst[i];
            ret.setValue(row.ID.toString(), row.Description);
        }

        return ret;
    }

    public TransformLanguageLookup(lst: Array<LanguageLookup>): Collections.Dictionary<string, string> {
        let ret = new Collections.Dictionary<string, string>();
        if (lst == null)
            return ret;

        for (let i = 0; i < lst.length; i++) {
            let row = lst[i];
            ret.setValue(row.LanguageCode, row.Language);
        }

        return ret;
    }

    public TransformToLookup(Master: Collections.Dictionary<number, PropertyMainMasters>): void {
        let keys = Master.keys();

        for (let i = 0; i < keys.length; i++) {
            let row = Master.getValue(keys[i]);

            let ret = new PropertyMainMasters_Transform();

            ret.Location = this.Transform_Id_Description(row.Location);

            ret.CallCategories = this.Transform_Id_Description(row.CallCategories);
            ret.CallDescriptions = this.Transform_Id_Description(row.CallDescriptions);
            ret.Staff = this.TransformGenericMaster(row.Staff);
            ret.Reason = this.TransformReasonLookup(row.Reason);
            ret.ComplainStatus = this.TransformGenericMaster_String(row.ComplainStatus);
            ret.Dept = this.TransformGenericMaster(row.Dept);
            ret.Desg = this.TransformGenericMaster(row.Desg);
            ret.DeviceType = this.TransformGenericMaster(row.DeviceType);
            ret.Sections = this.TransformGenericMaster(row.Sections);
            ret.Skill = this.TransformGenericMaster(row.Skill);

            //ret.Language = this.TransformLanguageLookup(row.Language);
            ret.Groups = this.TransformGenericMaster(row.Groups);
            ret.ComplainTypes = this.TransformGenericMaster(row.ComplainTypes);
            ret.VIPs = this.Transform_Id_Description(row.VIPs);
            ret.EventMaster = this.TransformGenericMaster(row.EventMaster);

            ret.GlitchRegistrationTypes = this.TransformGenericMaster(row.GlitchRegistrationTypes);
            ret.GlitchCategories = this.Transform_Id_Description(row.GlitchCategories);
            ret.GlitchDescriptionMaster = this.Transform_Id_Description(row.GlitchDescriptionMaster);
            ret.GlitchRecoveryOptionMaster = this.Transform_Id_Description(row.GlitchRecoveryOptionMaster);
            ret.GlitchActionReason = this.Transform_Id_Description(row.GlitchActionReason);

            row.TransformedObjects = ret;
        }
    }

    public GetMasterValue(master: Collections.Dictionary<number, PropertyMainMasters>, PropertyId: number, ID: any, EntityCode: any, CurrentValue: any): any {
        if (ID == null)
            return CurrentValue;

        let obj = master.getValue(+PropertyId);
        if (obj == null)
            return CurrentValue;

        if (obj.TransformedObjects.hasOwnProperty(EntityCode) == false)
            return CurrentValue;

        let lst: Collections.Dictionary<string, string> = obj.TransformedObjects[EntityCode];

        ID = ID.toString();

        if (lst.containsKey(ID) == false)
            return CurrentValue;

        return lst.getValue(ID);
    }

}

export class GlobalMasters {
    public Priority: Array<GenericMaster> = [];
    public GuestTemperamentMaster: Array<GenericMaster> = [];
}

class Currency {
    ChainId: number;
    Currency: string
    Id: number
    PropertyId: string
    Symbol: string
}

class DepartmentWhitelists {
    ChainId : number;
    DepartmentId : number
    Id : number
}

class Descriptions {
    ChainId : number;
    Id : number
    IsDel : boolean
    PropertyId : number
    WorkOrderDescription : string
}

class Reasons {
    ChainId : number
    Description : string
    Id : number
    IsDefault : boolean
    IsDel : number
    KsvReasonId : number
    ReasonType : number
}

class WorkOrderTypes { 
    ChainId : number
    Description : string
    Id : number
    IsDefault : boolean
    IsDel : number
    PropertyId : number
    TypeId : number
}
export class MNTMasters {
    public Currency : Currency[];
    public DepartmentWhitelists : DepartmentWhitelists[]
    public Descriptions : Descriptions[];
    public Reasons : Reasons[];
    public WorkOrderTypes : WorkOrderTypes[];
 
}
